<template>
  <div class="">
    <header class="page-header">
      <div class="ut-container-lg ut-relative ut-pb-3 md:ut-pb-8">
        <h1 class="ut-text-3xl ut-font-bold ut-pt-4 md:ut-pt-16">Welcome to Agent Portal</h1>
      </div>
    </header>
    <article>
      <div v-if="agent.key" class="ut-container-lg">
        <div class="ut-card-base">
          <h2 class="ut-text-2xl ut-pb-2">Create password</h2>
          <p class="ut-text-neutral-400">To finish your Agent Portal sign-up please create a password</p>
          <div class="form-group ut-mt-8">
              <p class="ut-pb-4"><strong>Username:</strong> {{  agent.email }}</p>
              <BannerInfo text="Your username and other personal details will be editable after password creation"/>
              <text-input
                class="ut-my-3"
                :label="form.password.label"
                :isMandatory="true"
                :type="Types.Input.Password"
                gacategory="Sign up"
                @validated-fields="validate"
                @input="onPasswordInput"
              />
              <text-input
                class="ut-my-3"
                :isMandatory="true"
                :label="form.passwordConfirm.label"
                :type="Types.Input.Password"
                :mustMatch="passwordValue"
                gacategory="Sign up"
                @validated-fields="validate"
                @input="onInput"
              />
              <CheckboxStandard class="ut-my-6"
                id="terms-checkbox"
                name="Do you accept the OpenAgent privacy policy, terms and conditions"
                v-model="terms.value"
                :checkboxValue="terms.value">
                I accept the <a :href="agentTermsUrl" class="ut-text-green-400 hover:ut-underline" target="_blank">agent terms and conditions</a>, <a :href="oaTermsUrl" class="ut-text-green-400 hover:ut-underline" target="_blank">general terms and conditions</a> and <a href="oaPrivacyPolicyUrl" class="ut-text-green-400 hover:ut-underline" target="_blank">privacy policy</a>.
                </CheckboxStandard>
              <span v-if="isError" id="error-message" class="error inline">
                {{ errorMsg }}
              </span>
              <oa-button
                class="ut-my-3"
                text="Sign-up"
                gacategory="Sign up"
                :btnClass="{ color: 'green' }"
                :disabled="disableSubmit"
                @click="clickedValidate" />
          </div>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import CheckboxStandard from '@oa-vue/checkbox-standard/CheckboxStandard.vue';
import OaButton from '@/components/Forms/OaButton.vue';
import TextInput from '@/components/Forms/TextInput.vue';
import BannerInfo from '@/components/BannerInfo.vue';
import FormHandler from '@/mixins/FormHandler';
import Types from '@/Mapper/CustomType';

export default {
  name: 'SignUp',
  props: {

  },
  components: {
    OaButton,
    TextInput,
    BannerInfo,
    CheckboxStandard,
  },
  mixins: [
    FormHandler,
  ],
  data() {
    return {
      disableSubmit: false,
      errorMsg: '',
      Types,
      form: {
        password: {
          label: 'Password',
          values: {},
        },
        passwordConfirm: {
          label: 'Confirm password',
          values: {},
        },
      },
      terms: {
        value: false,
      },
    };
  },
  computed: {
    ...mapState({
      agent: state => state.agentStore.agent,
    }),
    ...mapGetters('userStore', [
      'hasPortalAccount',
    ]),
    agentTermsUrl() {
      return `${process.env.VUE_APP_OA_URL}/agent-terms`;
    },
    oaTermsUrl() {
      return `${process.env.VUE_APP_OA_URL}/terms`;
    },
    oaPrivacyPolicyUrl() {
      return `${process.env.VUE_APP_OA_URL}/privacy-policy`;
    },
    passwordValue() {
      return this.form.password.values
        && this.form.password.values.value
        ? this.form.password.values.value
        : '';
    },
    passwordConfirmValue() {
      return this.form.passwordConfirm.values
        && this.form.passwordConfirm.values.value
        ? this.form.passwordConfirm.values.value
        : '';
    },
    isError() {
      return this.errorMsg !== '';
    },
  },
  watch: {
    hasPortalAccount() {
      if (this.hasPortalAccount) {
        this.redirect(this.agent.key, this.agent.userkey);
      }
    },
  },
  methods: {
    ...mapActions('userStore', {
      userSignUp: 'userSignUp',
    }),
    saveDetails() {
      console.log('form submitted');

      if (!this.terms.value) {
        this.errorMsg = 'Please accept the OpenAgent terms, conditions and privacy policy.';
        return false;
      }

      this.disableSubmit = true;
      this.errorMsg = '';
      const payload = {
        username: this.agent.email,
        password: this.passwordValue,
        agentkey: this.$route.params.ak,
        token: this.$route.params.st,
        'terms-accepted': this.terms.value,
      };

      this.userSignUp(payload).then((data) => {
        // console.log(data);

        // // Send GA event
        // this.$helpers.gaEvent(
        //   'AgentPortal',
        //   'Agent signup - Click sign-up',
        //   this.gaLabel,
        // );

        this.disableSubmit = false;
        this.redirect(this.agent.key, this.agent.userkey);
      }).catch((error) => {
        switch (error) {
          case 'Agent user already exists!':
            this.errorMsg = 'User aleady exists - please <a href=\'/\'>login</a>.';
            break;
          default:
            this.errorMsg = 'An error occurred.';
            break;
        }
        this.disableSubmit = false;
      });
    },
    onPasswordInput(values) {
      this.$emit(`${this.form.passwordConfirm.label}-set-value`, values.value, this.Types.Validation.MustMatch);
      this.onInput(values);
    },
    login(data) {
      const payload = {
        username: data.email,
        password: data.password,
      };

      this.logInUser(payload)
        .then((userData) => {
          this.resetInputs();
          this.disableSubmit = false;
          this.redirect(userData);
        })
        .catch((error) => {
          this.errorMsg = 'An error occurred.';
          console.error(error);
          this.disableSubmit = false;
        });
    },
    redirect(agentKey, userKey) {
      this.$router.push({
        name: 'account',
        params: {
          ak: agentKey,
          uk: userKey,
        },
        hash: this.$route.query.tab ? this.$route.query.tab : '',
      });
    },
  },
};
</script>

<style scoped lang="scss">

</style>
